import { useEffect, useState } from "react";

const THEME_KEY = "theme";

export default function useTheme() {
  const getSystemTheme = () =>
    window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";

  const [theme, setTheme] = useState(() => {
    const stored = localStorage.getItem(THEME_KEY);
    return stored || getSystemTheme();
  });

  useEffect(() => {
    const root = document.documentElement;

    // remove both first (avoid conflicts)
    root.classList.remove("light", "dark");

    // add current theme
    root.classList.add(theme);

    // persist
    localStorage.setItem(THEME_KEY, theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "light" ? "dark" : "light"));
  };

  return { theme, setTheme, toggleTheme };
}